module.exports = __webpack_public_path__ + "static/media/heatherraspberry.830a729a.jpg";